// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-option-container-yk8TZ {
  position: relative;
  color: black;
  box-sizing: content-box;
  border-radius: 50%;
  padding: 8px;
}

.navbar-option-container-yk8TZ:hover {
  background-color: rgb(0 0 0 / 0.04);
}

.navbar-option-container-yk8TZ:active, .navbar-option-active-ny1VT, .navbar-option-active-ny1VT:hover {
  color: black;
}

.navbar-option-icon-cLOJ9 {
  --size: 26px;
}

.navbar-option-indicator-RZiLl {
  width: 16px;
  height: 4px;
  display: none;
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--accent-color);
  border-radius: 2px;
}

.navbar-option-active-ny1VT > .navbar-option-indicator-RZiLl {
  display: block;
}

.navbar-option-label-ymOLq {
  position: absolute;
  top: 50%;
  left: 48px;
  opacity: 0;
  transition: opacity 200ms;
  white-space: nowrap;
  transform: translateY(-50%);
  pointer-events: none;
  background-color: rgb(95% 95% 95%);
  font-size: 13px;
  padding: 2px 8px;
  border-radius: 8px;
}

.navbar-option-showLabel-Axa0t {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/navbar-option/navbar-option.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".container {\n  position: relative;\n  color: black;\n  box-sizing: content-box;\n  border-radius: 50%;\n  padding: 8px;\n}\n\n.container:hover {\n  background-color: rgb(0 0 0 / 0.04);\n}\n\n.container:active, .active, .active:hover {\n  color: black;\n}\n\n.icon {\n  --size: 26px;\n}\n\n.indicator {\n  width: 16px;\n  height: 4px;\n  display: none;\n  position: absolute;\n  bottom: 2px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: var(--accent-color);\n  border-radius: 2px;\n}\n\n.active > .indicator {\n  display: block;\n}\n\n.label {\n  position: absolute;\n  top: 50%;\n  left: 48px;\n  opacity: 0;\n  transition: opacity 200ms;\n  white-space: nowrap;\n  transform: translateY(-50%);\n  pointer-events: none;\n  background-color: rgb(95% 95% 95%);\n  font-size: 13px;\n  padding: 2px 8px;\n  border-radius: 8px;\n}\n\n.showLabel {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `navbar-option-container-yk8TZ`,
	"active": `navbar-option-active-ny1VT`,
	"icon": `navbar-option-icon-cLOJ9`,
	"indicator": `navbar-option-indicator-RZiLl`,
	"label": `navbar-option-label-ymOLq`,
	"showLabel": `navbar-option-showLabel-Axa0t`
};
export default ___CSS_LOADER_EXPORT___;
